import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, map} from 'rxjs';
import {UserValidationService} from '../../services/user-validation.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private userValidationService: UserValidationService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (state.url.includes('/workspace-selection') && this.userValidationService.hasPendingCompanySelection()) {
      return true;
    }

    return this.userValidationService.ensureAuthenticatedSession().pipe(
      map((isLoggedIn) => {
        if (isLoggedIn) {
          return true;
        }

        this.router.navigate(['/login'], {
          queryParams: { returnUrl: state.url }
        });
        return false;
      })
    );
  }
}
